import EdoFundDetail from "./EdoFundDetail";

export default EdoFundDetail;
